<template>
  <div>
    <EditProductModal
      ref="editModal"
      v-bind="{ product, categories, tags, updating }"
      v-on="{ submit: handleProductUpdate }"
    />
  </div>
</template>

<script>
import { productMethods, productComputed } from '@/store/adminHelper';
import EditProductModal from '@/components/Products/EditProductModal.vue';
import { entityComputed } from '@/store/helper';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

export default {
  name: 'BaseProductEdit',
  mixins: [veeValidateErrorsMixin],
  components: {
    EditProductModal,
  },
  data: () => ({
    updating: false,
  }),
  computed: {
    ...entityComputed,
    ...productComputed,
    tags() {
      return Object.keys(this.$store.state.entities.tags.byId)
        .map((id) => this.entityById('tags', id))
        .filter((tag) => tag.taggableBy.indexOf('products') >= 0);
    },
  },
  methods: {
    ...productMethods,
    handleProductUpdate(productData) {
      this.updating = true;
      const { id: productId } = this.product;
      this.updateProduct({ productId, productData })
        .then(() => {
          this.updating = false;
          this.redirectToProduct();
        })
        .catch(({ errors = {} }) => {
          this.observer = this.$refs.editModal.$refs.observer;
          this.addServerErrors(errors);
          this.updating = false;
        });
    },
    redirectToProduct() {
      this.$router.go(-1);
    },
  },
};
</script>
